import { Typography, App } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

/** 全局唯一资源 ID（雪花 int64，JSON 以字符串传输），可复制供 OpenAPI 按 ID 换取 URL。 */
export function ResourceID({ id }: { id?: string | number }) {
  const { message } = App.useApp();
  if (id === undefined || id === null || id === '') {
    return <Typography.Text type="secondary">-</Typography.Text>;
  }
  const text = String(id);
  return (
    <Typography.Text
      className="resource-id"
      copyable={{
        text,
        tooltips: ['复制资源 ID', '已复制'],
        icon: [<CopyOutlined key="c" />, <CopyOutlined key="d" />],
        onCopy: () => message.success('资源 ID 已复制'),
      }}
      style={{ fontSize: 12, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace' }}
    >
      {text}
    </Typography.Text>
  );
}
